export const VARIANT_GROUP_IDS = {
  ROOMS: 1
}

export const FACT_ATTRIBUTE_IDS = {
  ATTRIBUTE_NAME: 190,
  CURRENCY_CODE: 613,
  COUNTRY_CODE: 614,
}

export const FACT_IDS = {
  CURRENCY: 917,
  COUNTRY: 916,
}
